export default __webpack_public_path__ + "static/media/grupoFarinter.0093e240.png";